export default "__VITE_ASSET__C$Hy0b5d__"